import React, { useState, useEffect, useRef } from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
import { FaPause, FaPlay } from "react-icons/fa";
import styles from "../styles/Other.module.css";
import moreStyles from "../styles/Community.module.css";
import Image from "next/image";
import { track } from "../utils/analytics";

const AudioPlayer3 = ({
  url,
  style,
  playing,
  setPlaying,
  postId,
  model,
  voice,
  original,
}) => {
  // const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const playerRef = useRef(null);
  const [hasWindow, setHasWindow] = useState(false);
  const [allowProgressUpdate, setAllowProgressUpdate] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setHasWindow(true);
    }
  }, []);

  useEffect(() => {
    if (!playerRef?.current || !allowProgressUpdate) return;
    const interval = setInterval(() => {
      if (playing) {
        const newProgress =
          (playerRef?.current?.getCurrentTime() /
            playerRef?.current?.getDuration()) *
          100;
        setProgress(newProgress);
      }
    }, 50);
    return () => clearInterval(interval);
  }, [playing, allowProgressUpdate]);

  const togglePlay = () => {
    if (playing === postId) {
      setPlaying(null);
    } else {
      setPlaying(postId);

      track("Played Demo", {
        model: model?.urlParam,
        voice: voice?.param,
        original: original,
      });
    }
  };

  const handlePlaybackEnd = () => {
    setPlaying(false);
    setProgress(0);
    playerRef?.current?.seekTo(0);
  };

  const handleProgressBarClick = (e) => {
    if (!playerRef.current) return;
    setAllowProgressUpdate(false);
    const progressBarRect = e.currentTarget.getBoundingClientRect();
    const newProgress =
      ((e.clientX - progressBarRect.x) / progressBarRect.width) * 100;
    const newTime = (newProgress * playerRef.current.getDuration()) / 100;
    const roundedTime = Math.round(newTime);
    playerRef.current.seekTo(roundedTime);
    setProgress((roundedTime / playerRef.current.getDuration()) * 100);
    setAllowProgressUpdate(true);
  };

  const iconSize = 20;
  return (
    <div
      style={{
        ...style,
        height: 48,
      }}
      className={`tw-rounded-xl tw-flex tw-items-center tw-gap-1 tw-px-3 tw-pr-5 tw-bg-purple-100 `}
      onClick={(e) => {
        e.preventDefault();
      }}
    >
      <div className={styles.freePlayerControlsContainer}>
        <div
          style={{
            color: "rgb(120, 45, 200, 1)",
          }}
          onClick={togglePlay}
          className="tw-flex tw-items-center tw-items-center tw-px-1.5 tw-cursor-pointer tw-pl-1"
        >
          {playing === postId ? (
            <FaPause size={iconSize} />
          ) : (
            <FaPlay size={iconSize} />
          )}
        </div>
      </div>
      <div
        style={{
          height: 30,
          width: "100%",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={handleProgressBarClick}
      >
        <div
          style={{ backgroundColor: "white" }}
          className={styles.freePlayerProgressBar}
        >
          <div
            className={styles.freePlayerProgress}
            style={{
              width: `${progress}%`,
              backgroundColor: "rgb(120, 45, 200, 1)",
            }}
          />
        </div>
      </div>
      {hasWindow && (
        <ReactPlayer
          style={{
            display: "none",
          }}
          onEnded={handlePlaybackEnd}
          ref={playerRef}
          url={url}
          playing={playing === postId ? true : false}
        />
      )}
      {/* {image && (
        <Image
          src={image}
          width={30}
          height={30}
          style={{ borderRadius: "50%", marginLeft: 5 }}
          quality={25}
        />
      )} */}
    </div>
  );
};
export default AudioPlayer3;
